module.exports = __webpack_public_path__ + "img/W-G16.4beaf1a0.jpg";